import styled from 'styled-components'
import ReactGA from 'react-ga4'
import LeftBar from '../home/components/leftBar'
import Auditoria from './body'

const Page = styled.div`
    display: flex;
    height: 100vh;
    overflow: hidden !important;
`

export default function AuditoriaPage() {
    ReactGA.send({
        hitType: 'pageview',
        page: '/admin/auditoria',
        title: 'Auditoria',
    })

    return (
        <Page>
            <LeftBar />
            <Auditoria />
        </Page>
    )
}
